// store/middleware/addressesCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const addressesCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type === "address-list/setAddresses") {
      const addresses = store.getState().addressList.data;

      if (addresses) {
        try {
          const version = getCacheVersion();
          const CACHE_KEY = `addresses_v${version}`;
          saveToStorage(CACHE_KEY, addresses);
        } catch (error) {
          console.error("Ошибка сохранения кэша адресов:", error);
        }
      }
    }

    return result;
  };